module.exports = __webpack_public_path__ + "assets/img/block-right-hover-218856c4.png";